<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Employee Assigned Customer</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"
                      ><i data-feather="home"></i
                    ></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item">Setup</li>
                  <li class="breadcrumb-item active">Employee Setup</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <!-- 1st -->
                    <div class="col-lg-5">
                      <div class="card-header p-0">
                        <h5>Unassigned</h5>
                        <span>Customer List</span>
                      </div>
                      <div class="table-responsive product-tabl">
                        <table class="display w-100">
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Action</th>
                          </tr>
                          <tbody>
                            <tr v-for="(item, i) in unassignList" :key="{ i }">
                              <td>{{ i + 1 }}</td>
                              <td>{{ item.name }}</td>
                              <td>
                                <input type="checkbox" @change="addAssign(item.id)" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <button
                          class="btn btn-sm btn-success"
                          @click="assignCustomer"
                          v-show="this.unassignList.length > 0"
                          :disabled="this.toAddList.length === 0"
                        >
                          Assign
                        </button>
                      </div>
                    </div>

                    <!-- 2nd -->
                    <div class="col-lg-7">
                      <div class="card-header p-0">
                        <h5>Assigned</h5>
                        <span>Customer List</span>
                      </div>
                      <div class="table-responsive product-tabl">
                        <table class="display w-100">
                          <tr>
                            <th>#</th>
                            <th>Name</th>
                            <!-- <th>Action</th> -->
                          </tr>
                          <tbody>
                            <tr v-for="(item, i) in assignList" :key="{ i }">
                              <td>{{ i + 1 }}</td>
                              <td>{{ item.customer_id + "customer" }}</td>
                              <!-- <td>
                                <button class="btn btn-sm btn-danger">x</button>
                              </td> -->
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

// import $ from "jquery";
import employeeAPI from "../../services/employee.API";

export default {
  name: "employeeCustomerAssigned",
  components: {},
  data() {
    return {
      unassignList: [],
      assignList: [],
      toAddList: [],
    };
  },

  methods: {
    addAssign(id) {
      if (this.toAddList.includes(id)) {
        var index = this.toAddList.indexOf(id);
        if (index !== -1) {
          this.toAddList.splice(index, 1);
        }
      } else {
        this.toAddList.push(id);
      }
    },

    assignCustomer() {
      let data = {
        user_id: 3,
        customer_id: this.toAddList,
      };

      employeeAPI
        .assignCustomer(data)
        .then((response) => {
          this.$moshaToast(response.data.message, {
            type: "success",
            position: "top-right",
            showIcon: true,
          });
          //   list
          employeeAPI.getUnassignList().then((response) => {
            this.unassignList = response.data.data;
          });

          //   list
          employeeAPI.getAssignList(2).then((response) => {
            this.assignList = response.data.data;
          });
          this.toAddList = [];
        })
        .catch((error) => {
          // console.log(error.response.data.success);
          if (error.response.data.success === false) {
            this.$moshaToast(error.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        });
    },
    // addNew
    // addNew() {
    //   //   console.log(this.title, this.status);
    //   if (this.title == "") {
    //     this.$moshaToast("Please enter Area title", {
    //       type: "danger",
    //       position: "top-right",
    //       showIcon: true,
    //     });
    //   } else if (this.price == "") {
    //     this.$moshaToast("Please enter price", {
    //       type: "danger",
    //       position: "top-right",
    //       showIcon: true,
    //     });
    //   } else {
    //     let data = {
    //       actual_price: this.price,
    //       title: this.title,
    //     };
    //     employeeAPI
    //       .createServiceType(data)
    //       .then((response) => {
    //         this.$moshaToast(response.data.message, {
    //           type: "success",
    //           position: "top-right",
    //           showIcon: true,
    //         });
    //         // get all connection type
    //         employeeAPI.getList().then((response) => {
    //           this.employeeList = response.data.data;
    //         });
    //         this.title = "";
    //         this.price = "";
    //       })
    //       .catch((error) => {
    //         // console.log(error.response.data.success);
    //         if (error.response.data.success === false) {
    //           this.$moshaToast(error.response.data.message, {
    //             type: "danger",
    //             position: "top-right",
    //             showIcon: true,
    //           });
    //         }
    //       });
    //   }
    // },

    // delete
    deleteType(id) {
      if (id) {
        employeeAPI.deleteEmployee(id).then((response) => {
          this.$moshaToast(response.data.message, {
            type: "success",
            position: "top-right",
            showIcon: true,
          });
          // get all connection type
          employeeAPI.getList().then((response) => {
            this.employeeList = response.data.data;
          });
        });
      } else {
        this.$moshaToast("Please select service type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },
  },
  mounted() {
    //   list
    employeeAPI.getUnassignList().then((response) => {
      this.unassignList = response.data.data;
    });

    //   list
    employeeAPI.getAssignList(2).then((response) => {
      this.assignList = response.data.data;
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}
th {
  text-align: center !important;
}
div.dragArea {
  border: 1px solid black;
  min-width: 100px;
}
td {
  text-align: center;
  padding: 5px 0;
  border-bottom: 1px solid gainsboro;
}
th {
  background: skyblue;
  text-align: center;
}
</style>
